import React from "react";

import { Button, Hairline, Label, Message, Radio } from "@components";
import { BaseCurrencyInput } from "@components/CurrencyInput/BaseCurrencyInput";
import { Drawer } from "../../../components/Drawer";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { If } from "shared/components/control-statements";

export default class GeneralDiscount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      configured: false,
      type: null,
      allowMessage: null,
      allowUpdate: null,
      value: null,
      loading: false,
    };
  }

  async componentDidUpdate(prevProps) {
    const { open } = this.props;
    if (prevProps?.open !== open && open) {
      this.load();
    }
  }

  async load() {
    const environmentId = await EnvironmentStorage.getSelectedEnvironment();

    const configs = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "catalog_discount",
      null
    );

    this.setState({
      configured: !!configs?.type,
      type: configs?.type,
      allowMessage: configs?.allowMessage,
      allowUpdate: configs?.allowUpdate,
      value: configs?.value,
    });
  }

  async save() {
    const { setOpen } = this.props;
    const { type, allowMessage, allowUpdate, value } = this.state;

    this.setState({ loading: true });

    const environmentId = await EnvironmentStorage.getSelectedEnvironment();

    const currentConfig = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "catalog_discount"
    );

    const newConfig = {
      catalog_discount: {
        ...currentConfig,
        type,
        allowMessage,
        allowUpdate,
        value,
      },
    };

    await EnvironmentsAPI.putConfigurationsByAlias(
      environmentId,
      "catalog_discount",
      newConfig
    );

    this.setState({
      loading: false,
      configured: true,
    });

    setOpen(false);
  }

  async reset() {
    this.setState({ loading: true });

    const environmentId = await EnvironmentStorage.getSelectedEnvironment();

    const newConfig = {
      catalog_discount: {},
    };

    await EnvironmentsAPI.putConfigurationsByAlias(
      environmentId,
      "catalog_discount",
      newConfig
    );

    this.setState({
      configured: false,
      loading: false,
      type: null,
      allowMessage: null,
      allowUpdate: null,
      value: null,
    });
  }

  render() {
    const { open, setOpen } = this.props;
    const { configured, type, value, loading } = this.state;

    return (
      <Drawer
        visible={open}
        onClose={() => setOpen(false)}
        title="Desconto geral e aviso"
        showBackButton
        backButton={() => setOpen(false)}
        withoutTransition
        footer={
          <div className="w-100">
            <If cond={type}>
              <Button
                design="primary"
                className="w-100"
                disabled={loading || !value}
                onClick={() => this.save()}
              >
                Salvar
              </Button>
            </If>

            <If cond={configured}>
              <Button
                className="w-100 mt-10"
                disabled={loading}
                onClick={() => this.reset()}
              >
                Desativar
              </Button>
            </If>
          </div>
        }
      >
        <Message>
          Ative um aviso para seus clientes de que seu cardápio está com
          desconto perante o seu marketplace.
        </Message>
        <Hairline className="mt-20 mb-20" />
        <Radio
          family="option"
          checked={type}
          value="ACTIVATE_ALL"
          onChange={() => this.setState({ type: "ACTIVATE_ALL", allowMessage: true, allowUpdate: true })}
          className="mb-10"
        >
          Ativar desconto geral e aviso
        </Radio>
        <Radio
          family="option"
          checked={type}
          value="ACTIVATE_WARNING_ONLY"
          onChange={() => this.setState({ type: "ACTIVATE_WARNING_ONLY", allowMessage: true, allowUpdate: false })}
          className="mb-10"
        >
          Ativar apenas aviso
        </Radio>
        <Radio
          family="option"
          checked={type}
          value="ACTIVATE_DISCOUNT_ONLY"
          onChange={() => this.setState({ type: "ACTIVATE_DISCOUNT_ONLY", allowMessage: false, allowUpdate: true })}
        >
          Ativar apenas desconto geral
        </Radio>

        {type === "ACTIVATE_ALL" && (
          <>
            <Hairline className="mt-20 mb-20" />
            <Label>Defina o desconto aplicado</Label>
            <BaseCurrencyInput
              className="w-100 pt-0"
              value={value}
              design="two"
              prefix=""
              suffix="%"
              precision={0}
              max="4"
              onChange={(v) => this.setState({ value: value > 10 ? 0 : v })}
            />
          </>
        )}

        {type === "ACTIVATE_WARNING_ONLY" && (
          <>
            <Hairline className="mt-20 mb-20" />
            <Label>Defina o desconto pré-definido</Label>
            <BaseCurrencyInput
              className="w-100 pt-0"
              value={value}
              design="two"
              prefix=""
              suffix="%"
              precision={0}
              max="4"
              onChange={(v) => this.setState({ value: value > 10 ? 0 : v })}
            />
          </>
        )}

        {type === "ACTIVATE_DISCOUNT_ONLY" && (
          <>
            <Hairline className="mt-20 mb-20" />
            <Label>Defina o desconto aplicado</Label>
            <BaseCurrencyInput
              className="w-100 pt-0"
              value={value}
              design="two"
              prefix=""
              suffix="%"
              precision={0}
              max="4"
              onChange={(v) => this.setState({ value: value > 10 ? 0 : v })}
            />
          </>
        )}
      </Drawer>
    );
  }
}
